<template>
  <section>
    <div class="row">
      <div class="col">
        <b-tabs
          fill
          v-model="tab_index"
          v-if="currently_playing_episode && ((currently_playing_episode.VL_file_exist === 'Y' && currently_playing_episode.VL_filetype === 'mp4') || (currently_playing_episode.AL_file_exist === 'Y' && currently_playing_episode.AL_filetype === 'mp3'))"
        >
          <b-tab
            active
            :title="$t('audiovisual-player.video.title')"
            :title-link-class="setTitleLinkClass(0)"
            v-if="currently_playing_episode.VL_file_exist === 'Y' && currently_playing_episode.VL_filetype === 'mp4'"
          >
            <video
              ref="video_player"
              class="video-js vjs-fluid"
              :lang="$i18n.locale === 'tw' ? 'zh-tw' : $i18n.locale"
            ></video>
            <br>
            <div class="vjs-playlist"></div>
          </b-tab>
          <b-tab
            :title="$t('audiovisual-player.audio.title')"
            :title-link-class="setTitleLinkClass(1)"
            v-if="currently_playing_episode.AL_file_exist === 'Y' && currently_playing_episode.AL_filetype === 'mp3'"
          >
            <audio
              ref="audio_player"
              class="video-js vjs-fluid"
              :lang="$i18n.locale === 'tw' ? 'zh-tw' : $i18n.locale"
            ></audio>
            <br>
            <div class="vjs-playlist"></div>
          </b-tab>
        </b-tabs>
        <div v-else>
          <h4>{{ $t('audiovisual-player.message.unsupported-format.0') }}</h4>
          <h4>{{ $t('audiovisual-player.message.unsupported-format.1') }}</h4>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue'

import videojs from 'video.js'
import videojs_playlist from 'videojs-playlist'
import videojs_playlist_ui from 'videojs-playlist-ui'

import { ButtonPlugin } from 'bootstrap-vue'
import { TabsPlugin } from 'bootstrap-vue'

import i18n from '@/plugins/i18n.js'

Vue.use(ButtonPlugin)
Vue.use(TabsPlugin)

videojs.addLanguage('zh-TW', {
  'Now Playing': '正在播放',
  'Up Next': '播放下一個',
  'Untitled Video': '未命名視訊'
})

videojs.addLanguage('en', {
  'Now Playing': 'Playing'
})

export default {
  i18n,
  name: 'series-audiovisual-player',
  props: {
    episodes: {
      type: Array,
      required: true
    },
    currently_playing_episode_index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      tab_index: 0,
      video_player: null,
      video_player_options: {
        autoplay: false,
        preload: 'none',
        controls: true,
        responsive: true,
        controlBar: {
          skipButtons: {
            forward: 10,
            backward: 10
          }
        },
        sources: []
      },
      video_player_playlist: [],
      currently_playing_video_index: -1,
      audio_player: null,
      audio_player_options: {
        autoplay: false,
        preload: 'none',
        controls: true,
        responsive: true,
        controlBar: {
          skipButtons: {
            forward: 10,
            backward: 10
          }
        },
        sources: []
      },
      audio_player_playlist: [],
      currently_playing_audio_index: -1
    }
  },
  computed: {
    currently_playing_episode: function () {
      return this.episodes[this.currently_playing_episode_index]
    }
  },
  methods: {
    setTitleLinkClass(index) {
      if (this.tab_index === index) {
        return ['bg-primary', 'text-white']
      } else {
        return ['bg-transparent', 'text-primary']
      }
    },
    setPlayerPlaylist() {
      this.episodes.forEach((episode, index) => {
        if (episode.VL_file_exist === 'Y' && episode.VL_filetype === 'mp4') {
          this.addToVideoPlayerPlaylist(episode)
          if (index === this.currently_playing_episode_index) {
            this.currently_playing_video_index = this.video_player_playlist.length - 1
          }
        }
        if (episode.AL_file_exist === 'Y' && episode.AL_filetype === 'mp3') {
          this.addToAudioPlayerPlaylist(episode)
          if (index === this.currently_playing_episode_index) {
            this.currently_playing_audio_index = this.audio_player_playlist.length - 1
          }
        }
      })
    },
    addToVideoPlayerPlaylist(episode) {
      this.video_player_playlist.push({
        name: `${episode.AV_fileorder}${episode.AV_fileorder_sub}`,
        description: episode.VL_filename,
        sources: [{ src: episode.VL_streaming_url, type: 'video/mp4' },],
        thumbnail: [
          {
            src: 'https://www2.budaedu.org/official-website-data/black.jpg',
            style: 'width:0.5em;height:3em;'
          }
        ]
      })
    },
    addToAudioPlayerPlaylist(episode) {
      this.audio_player_playlist.push({
        name: `${episode.AV_fileorder}${episode.AV_fileorder_sub}`,
        description: episode.AL_filename,
        sources: [{ src: episode.AL_streaming_url, type: 'audio/mp3' },],
        thumbnail: [
          {
            src: 'https://www2.budaedu.org/official-website-data/black.jpg',
            style: 'width:0.5em;height:3em;'
          }
        ]
      })
    },
    setVideoPlayer() {
      if (this.$refs.video_player != undefined) {
        this.video_player = videojs(
          this.$refs.video_player,
          this.video_player_options,
          () => { this.video_player.log('on_video_player_ready', this) }
        )

        this.video_player.playlist(this.video_player_playlist)
        this.video_player.playlist.autoadvance(0)
        if (this.currently_playing_video_index != -1) {
          this.video_player.playlist.currentItem(this.currently_playing_video_index)
        }

        this.video_player.playlistUi({ horizontal: true, language:'zh-Hant' })
      }
    },
    setAudioPlayer() {
      if (this.$refs.audio_player != undefined) {
        this.audio_player = videojs(
          this.$refs.audio_player,
          this.audio_player_options,
          () => { this.audio_player.log('on_audio_player_ready', this) }
        )

        this.audio_player.playlist(this.audio_player_playlist)
        this.audio_player.playlist.autoadvance(0)
        if (this.currently_playing_audio_index != -1) {
          this.audio_player.playlist.currentItem(this.currently_playing_audio_index)
        }

        this.audio_player.playlistUi({ horizontal: true, language:'zh-Hant' })
      }
    }
  },
  created() {
    //alert(`Vue version : ${Vue.version}`)
    this.setPlayerPlaylist()
  },
  mounted() {
    this.setVideoPlayer()
    this.setAudioPlayer()
  },
  beforeDestroy() {
    if (this.video_player) {
      this.video_player.dispose();
    }
    if (this.audio_player) {
      this.audio_player.dispose();
    }
  }
}
</script>